import { Routes, Route, Navigate } from "react-router-dom";

import ManagementChartsSection from "./sections/managementChartsSection";

function ChartsApp() {
  const data = JSON.parse(localStorage.getItem("userData") as string);

  return (
    <Routes>
      {(data?.settings?.analytics || (data?.claims?.includes('admin'))) ? (
        <>
          <Route path="/" element={<ManagementChartsSection />} />
          <Route path="/:id" element={<ManagementChartsSection />} />
        </>) :
        <Route path="*" element={<Navigate to="/page404" replace />} />
      }

    </Routes>
  )
}

export default ChartsApp;